import {
    browserName,
    fullBrowserVersion,
    isTablet,
    isMobile,
    isWindows,
    isMacOs
} from 'react-device-detect'
import { store } from 'reducers/store'

export const generateDeviceParams = () => {
    const userId = store.getState().auth.data?.UserId;
    const username = store.getState().auth.data?.UserName;

    return {
        'x-user-id': userId ?? 'anonymous',
        'x-user-name': username ?? 'anonymous',
        'x-browser-type': (() => {
            let deviceType

            if (isMobile) {
                deviceType = 'mobile'
            } else if (isTablet) {
                deviceType = 'tablet'
            } else {
                deviceType = 'desktop'
            }

            return deviceType
        })(),
        'x-browser-kind': browserName,
        'x-browser-version': fullBrowserVersion,

        'x-os-type': (() => {
            let osType

            if (isMacOs) {
                osType = 'macos'
            } else if (isWindows) {
                osType = 'windows'
            } else {
                osType = 'other'
            }

            return osType
        })()
    }
}